import { GenericFlightPathAssetsThumbnail } from "../generics/genericAssetsListThumbnails"
import { selectUserLocationShareById } from "features/entity-caching/flights/selectors"
import { fetchTelemetryEvents } from "tools/telemetry/fetchTelemetryEvents"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectActivatedFireId } from "features/map/control/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import useSWR from "swr"

export function UserLocationShareAssetsThumbnail({ id }: { id: string }) {
    const { data, isLoading } = useUserLocationShareMetadata({ id })
    return (
        <GenericFlightPathAssetsThumbnail
            id={id}
            selectEntity={selectUserLocationShareById}
            getMetadata={async () => data}
            isLoading={isLoading}
        />
    )
}

function useUserLocationShareMetadata({ id }: { id: string }) {
    const orgId = useAppSelector(selectActiveWorkspaceId())
    const projectId = useAppSelector(selectActivatedFireId)
    const { data, isLoading } = useSWR(
        orgId && projectId ? ["user-location-share-telemetry", orgId, projectId, id] : null,
        async () => {
            const { events } = await fetchTelemetryEvents({
                orgId: orgId!,
                projectId: projectId!,
                id,
            })
            return events.map(({ longitude, latitude }) => [
                longitude,
                latitude,
                0,
                0,
                0,
                0,
                0,
                0,
            ]) as [number, number, number, number, number, number, number, number][]
        },
        { revalidateOnFocus: false }
    )
    return { data, isLoading }
}
